import { requireTranslations } from '../../../common/translation';

export default requireTranslations((locale: string) => require(`./collection.${locale}.json`));
